var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trophy-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.828,
    height: 102.917,
    viewBox: "0 0 98.828 102.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M244.9,248.7V278.97H233.542V248.7a13.9,13.9,0,0,0,11.362,0Z",
    transform: "translate(-189.809 -185.791)",
    fill: "#f7b239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M239.537,250.192v29.514h-6V250.192a4.383,4.383,0,0,0,6,0Z",
    transform: "translate(-189.809 -186.904)",
    fill: "#e09b2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M220.542,348.566v12.9H184.235v-12.9a2.474,2.474,0,0,1,2.474-2.474h31.358A2.475,2.475,0,0,1,220.542,348.566Z",
    transform: "translate(-152.975 -258.545)",
    fill: "#f7b239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M191.438,346.092v15.37h-7.2v-12.9a2.474,2.474,0,0,1,2.474-2.474h4.729Z",
    transform: "translate(-152.975 -258.545)",
    fill: "#e09b2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M189.8,24.828h-2.6q.15-2.206.219-4.456.052-1.784.053-3.6H117.3q0,1.812.053,3.6.071,2.248.219,4.456.277,3.994.81,7.823a90.459,90.459,0,0,0,7.626,26.457,59.347,59.347,0,0,0,4.475,7.82c4.6,6.737,10.148,11.4,16.221,13.208a19.662,19.662,0,0,0,11.362,0c6.074-1.809,11.618-6.471,16.222-13.2h12.351A12,12,0,0,0,198.454,57l3.164-18.115A12,12,0,0,0,189.8,24.828Zm4.115,12.71-3.167,18.118a4.162,4.162,0,0,1-4.109,3.451h-7.876a90.548,90.548,0,0,0,7.629-26.457H189.8a4.179,4.179,0,0,1,4.115,4.888Z",
    transform: "translate(-102.971 -12.531)",
    fill: "#f7b239"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(0 4.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M107.835,80.136c-2.391-1.809-4.575-6.471-6.386-13.208-.635-2.362-1.227-4.982-1.762-7.82a206.084,206.084,0,0,1-3-26.457q-.206-3.825-.316-7.823-.108-3.957-.11-8.054H74.985q0,4.093.272,8.054h-2.6A12,12,0,0,0,60.838,38.888L64,57A11.993,11.993,0,0,0,75.82,66.931H88.17c4.6,6.736,10.146,11.4,16.219,13.2a19.845,19.845,0,0,0,5.682.839A3.688,3.688,0,0,1,107.835,80.136ZM71.709,55.657l-3.16-18.114a4.172,4.172,0,0,1,4.109-4.891h3.411a90.46,90.46,0,0,0,7.626,26.457H75.82A4.163,4.163,0,0,1,71.709,55.657Z",
    transform: "translate(-60.656 -16.774)",
    fill: "#e09b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M187.471,16.774c0,1.208-.019,2.409-.053,3.6H117.353c-.034-1.189-.053-2.391-.053-3.6Z",
    transform: "translate(-102.971 -16.774)",
    fill: "#e09b2d"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M175.208,0H101.026A2.826,2.826,0,0,0,98.2,2.826h0a2.826,2.826,0,0,0,2.826,2.826h74.183a2.826,2.826,0,0,0,2.826-2.826h0A2.825,2.825,0,0,0,175.208,0Z",
    transform: "translate(-88.703)",
    fill: "#f7b239"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M111.343,2.826A2.826,2.826,0,0,1,114.168,0H101.026a2.826,2.826,0,0,0,0,5.651h13.143A2.826,2.826,0,0,1,111.343,2.826Z",
    transform: "translate(-88.703)",
    fill: "#e09b2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6f6657122157d5f69902f5a214c9d736.svg";
export { ForwardRef as ReactComponent };